import React from 'react';
import { Modal, Button, Row } from 'react-bootstrap';
import domainName from '../../domainName';

const DeletePostModal = ({ show, onClose, deleteItem, t, onSuccess }) => {
  const handleDelete = async () => {
    try {
      const response = await domainName.serverAPICall(
        domainName.debugAPI + "/community/adminUpdateCommunityEnabled",
        "POST",
        JSON.stringify({
          "PostsId": deleteItem._id,
          "Enabled": "false"
        })
      );
      const result = await domainName.handleServerAPICallErrors(response);
      if (result.ReturnCode === 200) {
        if (onSuccess) {
          onSuccess(); // navigate('/community') from parent
        } else {
          window.location.reload(); // fallback
        }
      } else {
        alert(t("error.Failed to delete this post, please try it again later."));
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      onClose();
    }
  };

  return (
    <Modal show={show} onHide={onClose} fade={false}>
      <Modal.Header closeButton>
        <Modal.Title>{t('community.Delete Post')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row style={{ paddingLeft: '2%' }}>{t('community.Are you sure you want to delete this post')}</Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('community.Cancel')}
        </Button>
        <Button variant="primary" onClick={handleDelete}>
          {t('community.Confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePostModal;
